import React from 'react';
import { Card } from 'ui-toolkit';
import AddRowActions, { IAddRowAction } from './AddRowActions';
import CostData from './CostData';
import { generateSectionItems } from './generateSectionItems';
import IHasItemEventProps from './Items/IHasItemEventProps';
import { ICDV3ViewItem } from '../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';

interface IPayoffsAndPayments extends IHasItemEventProps<ICDV3ViewItem> {
  items?: ICDV3ViewItem[] | null;
  showSeller: boolean;
  payoffActions: IAddRowAction[];
  hasEditPermissions: boolean;
}

export default class PayoffsAndPayments extends React.Component<IPayoffsAndPayments> {
  public render() {
    const { items, onChange, onRemove, payoffActions, showSeller, hasEditPermissions } = this.props;
    return (
      <div data-test-id="payoffs">
        <Card className="payoffs-and-payments" title="Payoffs and payments" hasEditPermissions={hasEditPermissions}>
          {items && items.length ? (
            <CostData
              data-test-id={`payoffs`}
              className="cost-data--payoff"
              mode="payoff"
              addRowActions={payoffActions}
            >
              {generateSectionItems(items, { onChange, onRemove, showSeller, hasEditPermissions })}
            </CostData>
          ) : (
            <AddRowActions
              disabled={!hasEditPermissions}
              data-test-id={mergeTests(`payoffs`, `action`)}
              addRowActions={payoffActions}
            />
          )}
        </Card>
      </div>
    );
  }
}
